import {Tr} from "@/i18n/i18n";
import Scene = Phaser.Scene;
import {Keys} from "@/constants/key";
import TextUtils from "@/utils/text-utils";
import {RuneInfo} from "@/store/artifact/types";
import {SquareButton} from "@/scenes.ui/square-button";
import {Fonts} from "@/constants/font";
import {VerticalStandardPanel} from "@/scenes.ui/vertical-standard-panel";
import SpriteUtils from "@/utils/sprite-utils";

export class RunePickPanel extends VerticalStandardPanel {

    private exitCallback: () => unknown;
    private takeCallback: () => unknown;

    constructor(scene: Scene, canvas: HTMLCanvasElement, x: number, y: number, ri: RuneInfo,
                exitCallback: () => unknown, takeCallback: () => unknown) {
        super(scene, canvas, Tr('novaja.nahodka'));
        const self = this;

        this.exitCallback = exitCallback;
        this.takeCallback = takeCallback;

        let infoText = TextUtils.addTextByFamily(scene, ri.name.toUpperCase(),
            0, -180, '#ffd465', 18, 'normal', 450, Fonts.MYRIADPRO_BOLD);

        let improveLabel = TextUtils.addTextAdvanced(scene, Tr('prigoditsja.dlja.uluchshenija'), 0, -30,
            '#716f6a', 12, 'normal', 450, 'center', 2, Fonts.ARIAL_MT).setVisible(!ri.multiUse);

        let improveLabel2 = TextUtils.addTextAdvanced(scene, Tr('openly.improve') + String(ri.level) + Tr('level.up'), 0, -30,
            '#828180', 12, 'normal', 450, 'center', 2, Fonts.ARIAL_MT).setVisible(ri.multiUse);

        let artIcon = SpriteUtils.addSprite(this.scene, 0, -110, ri.atlasKey, ri.imageKey);

        let takeButton = new SquareButton(this.scene, 0, 130, 0, Keys.UI_ART_GREEN_BUTTON,
            Keys.ATLAS_PROFILE, Keys.UI_GOLDEN_CHECK, Tr('vzjat'), false);

        takeButton.setCallback(() => {
            takeCallback();
            self.setVisible(false);
            self.destroy();
        });

        this.add([infoText, artIcon, takeButton, improveLabel, improveLabel2]);

        let posY = 0;
        for (let a of ri.artNames.slice(0, 1)) {
            let improveText = TextUtils.addTextAdvanced(scene, a.toUpperCase(), 0, posY,
                '#fff5e2', 13, 'normal', 450, 'center', 2, Fonts.ARIAL_MT);
            self.add(improveText);
            posY += 20;
        }
    }

    protected onClose(): void {
        this.exitCallback!();
    }

}
